/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-unstable-nested-components */
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import '../../styles/MarkdownRenderer.css';

const MarkdownRenderer = ({ content, variant }) => (
  <div className={`markdown-wrapper${variant ? ` markdown-wrapper--${variant}` : ''}`}>
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        h3: ({ node, ...props }) => (
          <h3 className="md-heading" {...props} />
        ),
        ul: ({ node, ...props }) => (
          <ul className="md-list" {...props} />
        ),
        table: ({ node, ...props }) => (
          <div className="md-table-wrapper">
            <table className="md-table" {...props} />
          </div>
        ),
        th: ({ node, ...props }) => (
          <th className="md-th" {...props} />
        ),
        td: ({ node, ...props }) => (
          <td className="md-td" {...props} />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  </div>
);

export default MarkdownRenderer;
